import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type ComplianceRuleDefinitionRecord = QueryAtomResult<
  typeof queryComplianceRuleDefinitionsAtom
>[number];

export const queryComplianceRuleDefinitionsAtom = createQueryAtomFactory(
  'settings.complianceRuleDefinitions',
  () => ({
    complianceRuleDefinitions: {
      __args: {
        pagination: {
          offset: 0,
          limit: 100,
        },
      },
      entries: {
        id: true,
        ruleCode: true,
        name: true,
        description: true,
        category: true,
        dataType: true,
        defaultValue: true,
        allowedValues: true,
        jurisdictionCode: true,
        enforcementLevel: true,
        appliesTo: true,
        isSystem: true,
        isActive: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) =>
      data?.complianceRuleDefinitions.entries.map((def) => ({
        id: def.id,
        ruleCode: def.ruleCode,
        name: def.name,
        description: def.description,
        category: def.category,
        dataType: def.dataType,
        defaultValue: def.defaultValue,
        allowedValues: def.allowedValues,
        jurisdictionCode: def.jurisdictionCode,
        enforcementLevel: def.enforcementLevel,
        appliesTo: def.appliesTo,
        isSystem: def.isSystem,
        isActive: def.isActive,
        createdAt: def.timestamps.createdAt,
        updatedAt: def.timestamps.updatedAt,
      })) ?? [],
  },
);
